import isObject from 'lodash.isobject';

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const CLEAR = 'CLEAR_REQUEST';
export const SET_LOAD = 'SET_LOAD';

export const cleaRequest = requestName => ({
  type: CLEAR,
  payload: requestName,
});

export const setLoad = load => ({
  type: SET_LOAD,
  payload: load,
});

export const resetPrintData = () => ({
  type: CLEAR,
  payload: 'ARIFMETIKBOOK/REQUEST_GET_ARGS_TO_PRINT',
});

const states = {
  error: false,
  success: false,
  loading: false,
  errorMessage: '',
};

export const combineRequests = crudList =>
  Object.keys({ ...states })
    .map(v => crudList.find(r => r && r[v]) && crudList.find(r => r && r[v])[v])
    .reduce(
      (accumulator, item, index) => {
        const result = accumulator;
        result[Object.keys(accumulator)[index]] = item;
        return result;
      },
      { ...states }
    );

const entity = (state = { ...states }, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        error: false,
        success: false,
        loading: true,
      };
    case SUCCESS:
      return {
        ...state,
        error: false,
        success: true,
        loading: false,
        data: isObject(action.payload) ? action.payload.data : action.payload,
        template: isObject(action.payload)
          ? action.payload.template || null
          : null,
        gamification: isObject(action.payload)
          ? action.payload.gamification
          : action.payload,
      };
    case FAILURE:
      return {
        ...state,
        error: true,
        success: false,
        loading: false,
        errorMessage: action.payload.response.data,
      };
    default:
      return state;
  }
};

// Reducer
const requestReducer = (state = { load: false }, action) => {
  switch (action.type) {
    case REQUEST:
    case SUCCESS:
    case FAILURE:
      return {
        ...state,
        [action.meta.request]: entity(state[action.meta], action),
      };

    case SET_LOAD:
      return { ...state, load: action.payload };

    case CLEAR:
      if (action.payload) {
        return {
          ...state,
          [action.payload]: undefined,
        };
      }
      return {};

    default:
      return state;
  }
};

export default requestReducer;
